module.exports = __webpack_public_path__ + "img/hello_kartik.68ba37b0.svg";